;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('coreDataFrameTable', coreDataFrameTable)

  /* @ngInject */
  function coreDataFrameTable () {
    return {
      restrict: 'E',
      scope: {
        data: '<',
        loading: '<',
        multiselection: '<'
      },
      templateUrl: '/core/directives/core-data-frame-table/core-data-frame-table-directive.html?$$REVISION$$',
      controller: 'CoreDataFrameTableController'
    }
  }
})()
